import BadgesSection from './BadgesSection.jsx';

export default BadgesSection;